<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
  {{'title.add_customer_from_file' | translate}}
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-panel-title class="mat-panel-title">

</mat-panel-title>
<div class="pb-3">
  <p *ngIf="!haveErrorResult">{{'hint.attach_info_upload_title_1' | translate}}<a [routerLink]=""
      (click)="downFileTemplateExcelAddCustomer($event)">{{'hint.attach_info_upload_title_2' |
      translate}}</a>{{'hint.attach_info_upload_title_3' | translate}}</p>
  <span class="text-danger" *ngIf="haveErrorResult">{{'hint.import_customer_have_error' | translate}}</span>
  <app-upload-file [isCustomer]="true"></app-upload-file>
  <div class="text-center">
    <mat-hint class="hint-text" *ngIf="!haveErrorResult">
      {{'hint.attach_accept_customer_from_file' | translate}}<br>
    </mat-hint>
  </div>
</div>
<div mat-dialog-actions class="justify-content-center mt-2">
  <div class="mt-2">
    <button mat-stroked-button color="primary" (click)="onNoClick()" type="button">
      <mat-icon>cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
  </div>
  <div class="pl-3 pt-2">
    <button type="button" mat-raised-button color="primary" [disabled]="!haveFileUpload" (click)="onUploadFileCustomer()">
      <mat-icon>done</mat-icon>
      {{'button.add_customer' | translate}}
    </button>
  </div>
</div>